import IMessage from '../../models/Message';
import { IMessageDetails } from '../../models/MessageDetails';

/**
 * Maps a message object from the API response to MessageDetails format
 * This eliminates the need for a separate API call to get message details
 */
export function mapMessageToDetails(message: IMessage): IMessageDetails {
    return {
        id: message.messageID,
        message: message.message || '',
        stackTrace: message.stackTrace || '',
        insights: message.aiAction ? {
            aiTranslation: message.aiAction.aiProbableCause || '',
            recommendations: [
                message.aiAction.aiRecommendedAction,
                message.aiAction.aiEscalationJustification
            ].filter(Boolean) as string[]
        } : undefined,
        score: {
            similarityScore: message.similarMessageScore || 0,
            isFlaggedForReview: message.flagForHumanReview,
            flagReason: message.humanReviewReason || undefined
        },
        escalation: message.escalationAction ? {
            escalationPriority: message.escalationPriority || 0,
            assignedTo: message.escalationAction.escalationActionName ? {
                name: message.escalationAction.escalationActionName || 'Unassigned',
                description: message.escalationAction.description || 'Support Engineer'
            } : undefined
        } : undefined
    };
}